// src/utils/colorSorter.js
import * as THREE from 'three';

// hexToHsl 函数保持不变
function hexToHsl(hex) {
    const tempColor = new THREE.Color(hex);
    const hsl = { h: 0, s: 0, l: 0 };
    tempColor.getHSL(hsl);
    return hsl;
}

// getColorFamily 函数保持不变
function getColorFamily(hsl) {
    const { h, s, l } = hsl;
    if (s < 0.25 && l > 0.8) return 'White';
    if (s < 0.1 || l < 0.2) return 'Other';
    const hue = h * 360;
    if ((hue >= 0 && hue < 30) || (hue >= 330 && hue <= 360)) return 'Red';
    if (hue >= 30 && hue < 70) return 'Yellow';
    if (hue >= 70 && hue < 160) return 'Green';
    if (hue >= 160 && hue < 260) return 'Blue';
    return 'Red';
}

/**
 * 【新函数】将颜色点按色系进行分组
 * @param {Array} colorPoints - 原始颜色点数组
 * @returns {object} - 返回一个包含各色系颜色数组的对象
 */
export function groupColorsByHue(colorPoints) {
    const groups = {
        Red: [],
        Yellow: [],
        Green: [],
        Blue: [],
        White: [],
        Other: [],
    };
    
    // 【重要修正】使用 Array.isArray 来进行严格的数组检查
    // 这可以防止当 colorPoints 是一个对象而不是数组时程序崩溃
    if (!Array.isArray(colorPoints) || colorPoints.length === 0) {
        return groups;
    }

    // 现在这行代码是安全的了
    for (const point of colorPoints) {
        const hsl = hexToHsl(point.color.hex);
        const family = getColorFamily(hsl);
        groups[family].push(point);
    }
    return groups;
}

// 【新增】定义色系顺序
export const colorFamilyOrder = ['Red', 'Yellow', 'Green', 'Blue', 'White', 'Other'];

// 【新增】测试数据，方便您继续验证
export const mockColorData = [
  { id: 'test-r1', color: { hex: '#D92E2E' }, element: 'Red 1' }, { id: 'test-r2', color: { hex: '#C70039' }, element: 'Red 2' },
  { id: 'test-y1', color: { hex: '#FFC300' }, element: 'Yellow 1' }, { id: 'test-y2', color: { hex: '#F9A825' }, element: 'Yellow 2' },
  { id: 'test-g1', color: { hex: '#4CAF50' }, element: 'Green 1' }, { id: 'test-g2', color: { hex: '#2E8B57' }, element: 'Green 2' },
  { id: 'test-b1', color: { hex: '#2196F3' }, element: 'Blue 1' }, { id: 'test-b2', color: { hex: '#00BCD4' }, element: 'Blue 2' },
  { id: 'test-w1', color: { hex: '#F5F5F5' }, element: 'White 1' }, { id: 'test-w2', color: { hex: '#E0E0E0' }, element: 'White 2' },
//   { id: 'test-o1', color: { hex: '#795548' }, element: 'Brown' }, { id: 'test-o2', color: { hex: '#607D8B' }, element: 'Blue Grey' },
];